import React, { useEffect } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Button,
  Heading,
  Box,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { deleteUser, getUsers } from "../redux/admin/admin.actions";

const UserList = () => {
  const { users } = useSelector((store) => store.admin);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUsers());
  }, []);

  const handleDelete = (id) => {
    dispatch(deleteUser(id));
  };

  let count = 1;
  return (
    <Box>
      {users.length > 0 ? (
        <TableContainer>
          <Heading textAlign={"center"}>User List</Heading>
          <Table variant="striped" colorScheme="teal">
            <Thead>
              <Tr>
                <Th c>Sr.No.</Th>
                <Th textAlign={"center"}>User Email</Th>
                <Th textAlign={"center"}>User Id</Th>
                <Th textAlign={"center"}>Delete</Th>
              </Tr>
            </Thead>
            <Tbody>
              {users?.map((el) => (
                <Tr key={el._id}>
                  <Td textAlign={"center"}>{count++}</Td>
                  <Td textAlign={"left"}>{el.email}</Td>
                  <Td textAlign={"left"}>{el._id}</Td>
                  <Td textAlign={"center"}>
                    <Button
                      colorScheme="red"
                      onClick={() => handleDelete(el._id)}
                    >
                      Delete
                    </Button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      ) : null}
    </Box>
  );
};

export default UserList;
